import { defaultTheme } from 'shared/theme/theme';
import styled from 'styled-components';

const SitePage = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin: auto;
  footer {
    min-height: 5em;
    width: 100%;
    font-family: ${p => p.theme.font};
    div {
      color: ${defaultTheme.colors.aux.darkGrey};
    }
  }
`;

export default SitePage;
